import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';
import { useParams } from 'react-router-dom';

const TaxSlabInput = () => {
  const { taxSlabId = '' } = useParams();
  const decodedId = taxSlabId ? atob(taxSlabId) : taxSlabId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [taxTypes, setTaxTypes] = useState([]);
  const route = 'tax_slab';

  useEffect(() => {
    if (taxSlabId) {
      setIsEditing(true);
      fetchTaxSlabDetails();
    }
    fetchTaxType();
  }, [taxSlabId]);

  const fetchTaxSlabDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.tax_slab}${id}/`, { headers });
      const taxSlabDetails = response.data;

      setFormData(taxSlabDetails);
    } catch (error) {
      console.error('Error fetching tax slab details:', error);
    }
  };

  const fetchTaxType = async () => {
        try {
            const response = await axios.get(`${API_DOMAIN}${API_ROUTES.tax_type}`, { headers });
            const taxTypes = response.data;

            const taxTypeOptions = taxTypes.map(taxType => ({
            value: taxType.id,
            label: taxType.name,
            }));



            //console.log(taxTypeOptions)

         
            setTaxTypes(taxTypeOptions);
        } catch (error) {
            console.error('Error fetching tax types:', error);
        }
    };

  const handleFormSubmitSuccess = (response) => {
    
  };

  const taxSlabFields = [
    {
      name: 'tax_type',
      label: 'Tax Type',
      type: 'select',
      options: taxTypes,
    },
    {
      name: 'min_income',
      label: 'Minimum Income',
      type: 'number',
    },
    {
      name: 'max_income',
      label: 'Maximum Income',
      type: 'number',
    },
    {
      name: 'rate',
      label: 'Rate(Percentage)',
      type: 'number',
    },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Tax Slab' : 'Create Tax Slab'}</h1>
      <FormComponent
        fields={taxSlabFields}
        initialFormData={formData}
        route={route}
        onSubmitSuccess={handleFormSubmitSuccess}
        onSubmitError={() => {}}
      />
    </div>
  );
};

export default TaxSlabInput;